import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from 'gatsby'
import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { theme1, theme2, theme3, theme4, theme5, theme6, theme7, theme8 } from '../theme'
import PasifikiContext from '../resources/context'
import Header from './header'
import Footer from './footer'

const Layout = ({ children, active }) => {
	const data = useStaticQuery(graphql`
		query SiteTitleQuery {
			site {
				siteMetadata {
					title
				}
			}
		}
	`)
	
	const context = useContext(PasifikiContext)
	const [currentThemeNr, setCurrentThemeNr] = useState(context.theme || 6)

	const changeTheme = (event) => {
		setCurrentThemeNr(Number(event.target.value))
		context.theme = Number(event.target.value)
	}

	return (
		<ThemeProvider
			theme={
				currentThemeNr === 0
					? theme1
					: currentThemeNr === 1
					? theme2
					: currentThemeNr === 2
					? theme3
					: currentThemeNr === 3
					? theme4
					: currentThemeNr === 4
					? theme5
					: currentThemeNr === 5
					? theme6
					: currentThemeNr === 6
					? theme7
					: theme8
			}
		>
			<CssBaseline />
			<Header
				siteTitle={data.site.siteMetadata.title}
				active={active}
				changeTheme={changeTheme}
				currentThemeNr={currentThemeNr}
				nbrOfThemes={8}
			/>
			<>{children}</>
			<Footer />
		</ThemeProvider>
	)
}

Layout.propTypes = {
	children: PropTypes.node.isRequired
}

export default Layout
